<template>
	<div class="statistica__per-month">
		<div v-for = "(item,index) in weekSum" :key="index" class="statistica__item">
            <div class="statistica__per-month-title">{{item[item.length -1].title}}-я Торговая неделя
                <span>/ {{item[0].dateFormat}} - {{item[item.length -2].dateFormat}} </span>
            </div>
            <div>
                <table class="statistica__per-month-row">
                    <tr v-for = "(day, number) in item" :key="number + 'day'" v-if="!day.title" class="statistica__per-month-item">
                        <td class="statistica__per-month-item-title-day">{{day.weekDayName}}</td>
                        <td class="statistica__per-month-item-title-date">{{day.dateFormat}}</td>
                        <td class="statistica__per-month-item-data-sum"
                                :class = "((day.profitAbs < 0) ? 'color-red' : 'color-green')">$ {{day.profitAbs}}</td>
                        <td class="statistica__per-month-item-data-pips"
                                :class = "((day.profitRel < 0) ? 'color-red' : 'color-green')">{{(day.profitRel).toFixed(2)}}%</td>
                        <td class="statistica__per-month-item-data-probability">{{(day.equityOnEod).toLocaleString('ru')}}</td>
                        <td class="statistica__per-month-item-data-maxdd">{{(day.maxDd).toFixed(2)}}</td>
                    </tr>
                    <tr v-for = "(day, number) in item" :key="number + 'day'" v-if="day.title" class="statistica__per-month-item">
                        <td class="statistica__per-month-item-title-day">Итог</td>
                        <td class="statistica__per-month-item-title-date"></td>
                        <td class="statistica__per-month-item-data-sum"
                            :class = "((day.profitAbs < 0) ? 'color-red' : 'color-green')">$ {{day.profitAbs}}</td>
                        <td class="statistica__per-month-item-data-pips"
                            :class = "((day.profitRel < 0) ? 'color-red' : 'color-green')">{{(day.profitRel).toFixed(2)}}%</td>
                        <td class="statistica__per-month-item-data-probability">{{(day.equityOnEod).toLocaleString('ru')}}</td>
                        <td class="statistica__per-month-item-data-maxdd">{{(day.maxDd).toFixed(2)}}</td>
                    </tr>
                </table>
                    <div class="statistica__per-month-item-chart">
                        <week-chart
                        :week="index"
                        ></week-chart>
                    </div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import WeekChart from './sig-profitability-chart-week'

export default {
	components: {
        'week-chart':WeekChart
    },
	props: {
		symbol: { default: '' }
	},
	data() {
		return {
            weekSum: {},
		};
	},
	computed: {
		...mapGetters({
              getMonthStat: 'accountstat/getMonthStat',
        }),
        getWeeksWithOutSummary() {
            if(this.weekSum.week.length > 1)
            return 1
        }
	},
	methods: {

	},
	created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            if (!this.symbol || !this.symbol.length) {
                let stat = this.getMonthStat(this.symbol);
                stat.week.pop();
                Vue.set(this, 'weekSum', stat.week)
            }
        });

    } // created }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-weeks-left-widget",
            handler: handler
        }
    });
}
</script>

<style lang="less" scoped>
.statistica__item {
    margin-bottom: 8px;
    display: block;
    background: #3d536b;
    border-radius: 4px;
    overflow: hidden;
}
.statistica__per-month {
    width: 100%;
    &-title {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #ffffff;
        padding-left: 12px;
        background-color: #3d536b;
        margin-bottom: 0px;
        span {
            font-weight: normal;
            color: #aabed2;
        }
    }

    &-row {
        width: 100%;
        border-bottom: 1px solid #374b62;
    }

    &-item {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        height: 29px;
        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 12px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-right: 12px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &-sum {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: @colors[red];
                }
        }

        &-chart {
            width: 100%;
            display: block;
            //flex-grow: 1;
            min-height: 200px;
        }
    }
}
</style>
